import { ChangeDetectorRef, Component, Input, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListingService } from 'src/app/modules/auth/services/listing.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { CompanySettingsService } from 'src/app/modules/auth/services/company-settings/company-settings.service';
import { AuthService } from 'src/app/modules/auth';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfig } from 'src/app/_metronic/partials';
import { Lightbox } from 'ngx-lightbox';
import { AnyAaaaRecord } from 'dns';

@Component({
  selector: 'app-listing-view',
  templateUrl: './listing-view.component.html',
  styleUrls: ['./listing-view.component.scss'],
})
export class ListingViewComponent {
  companySettings:any;
  IsLoading: boolean;
  previewData: any;
  public baseUrl = '';
  baseUrlImage = environment.imgUrl;
  frontendUrl = environment.frontendUrl;
  displayFilesPhotos: any;
  agentPhoto :any;
  maxImageCount:any = 5;
  photosdisplay:any = [];
  displayFilesFloorPlan: any;
  displayFilesPDFBrochure: any;
  displayFilesVideos: any;
  displayView: boolean;
  featuresList: any = [];
  display1stImage: boolean;
  display2ndImage: boolean;
  display3rdImage: boolean;
  display4thImage: boolean;
  mapDisplay: boolean;
  companymarketingData:any;
  companyImagePath:any;
  listingDeafaultImage:any;
  companyImgFile:any = null;
  mapLocation: string;
  imgUrl = environment.imgUrl;
  selectedLanguages: string[] = [];
  userData:any;
  companyId:any;
  @ViewChild('photos') private modalContent: TemplateRef<ListingViewComponent>;
  @ViewChild('slickModal') slickModal: any;
  @Input() public modalConfig: ModalConfig;
  private modalRef: NgbModalRef;
  constructor(
    private route: ActivatedRoute,
    private listingSevice: ListingService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private companySettingsService: CompanySettingsService,
    private authService: AuthService,
    private modalService: NgbModal,
    private _lightbox: Lightbox,
    private renderer: Renderer2,
  ) {}
  

  async ngOnInit() {
    const floatingBtnKnwolarity = document.querySelector('#floating-button-knowlarity');
    if (floatingBtnKnwolarity) {
      this.renderer.setStyle(floatingBtnKnwolarity, 'display', 'none');
    }

    const InfoContainerKnwolarity = document.querySelector('#popup-container-knowlarity');
    if (InfoContainerKnwolarity) {
      this.renderer.setStyle(InfoContainerKnwolarity, 'display', 'none');
    }


    this.mapLocation = '';
    this.mapDisplay = false;
    this.cdr.detectChanges();

    this.route.queryParams.forEach(async (params: any) => {
        console.log('QUERYPARAMS');
        console.log(params);

        this.IsLoading = true;

        // Use await to ensure that getListingDetail completes before moving on
        const listingDetails = await this.getListingDetail(params.id);


        // Now, you can safely access the companyId
        const x = await this.getCompanySettings(this.companyId);

        // After awaiting getCompanySettings, you can access this.companySettings
        console.log("compnaysetting console",this.companySettings);

        const y = await this.getCompanyLogoImg(this.companyId);
        

        this.baseUrl = this.baseUrlImage +this.companyId+ '/ListingDetails/';

        const getPhtots = await this.getImagePhotos('Photos', params.id);
        console.log(this.photosdisplay);
        // The rest of your code...
        const getFeatures = await this.getFeaturesbyId(params.id);
        this.cdr.detectChanges();
    });
}



  getImageFloorPhotos(data: any, id: any) {
    this.displayFilesFloorPlan = [];
    this.listingSevice
      .GetAllImagesPath(data, id)
      .subscribe((data: any | undefined) => {
        this.displayFilesFloorPlan = data;
      });
  }
  getImagePDFBrochure(data: any, id: any) {
    this.displayFilesPDFBrochure = [];
    this.listingSevice
      .GetAllImagesPath(data, id)
      .subscribe((data: any | undefined) => {
        this.displayFilesPDFBrochure = data;
      });
  }
  getImageVideos(data: any, id: any) {
    this.displayFilesVideos = [];
    this.listingSevice
      .GetAllImagesPath(data, id)
      .subscribe((data: any | undefined) => {
        this.displayFilesVideos = data;
      });
  }

  async getFeaturesbyId(id: string):Promise<any> {
    return new Promise<boolean>((resolve, reject) => {
    this.featuresList = [];
    this.listingSevice
      .getFeaturesById(id)
      .subscribe((data: any | undefined) => {
        data.forEach((element: any) => {
          if (element.checked) {
            this.featuresList.push(element);
          }
        });
        resolve(true);
      });
    });
  }
  getMapLocation() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.mapLocation);
  } 
  async getCompanyLogoImg(id: any):Promise<any> {
    return new Promise<boolean>((resolve, reject) => {
      this.companySettingsService
        .getCompanyMarkettingImages(id)
        .subscribe((data: any | undefined) => {
          console.log("data.result",data.result)
          this.companymarketingData = data.result;
          if(this.companymarketingData?.companyLogoPath != '' && this.companymarketingData?.companyLogoPath != null){
           
            this.companyImagePath = `${this.imgUrl}${this.companyId+'/'}${this.companymarketingData.companyLogoPath}`;
            console.log(this.companyImagePath);
          }else{
            // this.companyImagePath = "https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/8462ea22404695.563122125aca7.jpg";
          }
           if(this.companymarketingData?.defaultListingImagePath != '' && this.companymarketingData?.defaultListingImagePath != null){
            this.listingDeafaultImage = `${this.imgUrl}${this.companyId+'/'}${this.companymarketingData.defaultListingImagePath}`;
            console.log(this.listingDeafaultImage);
          }else{
            // this.listingDeafaultImage="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/8462ea22404695.563122125aca7.jpg";
            
            this.listingDeafaultImage = this.frontendUrl +"assets/media/logos/listingDefault.png";
          }
          resolve(true);
        });
      });
      }

      async getCompanySettings(id: any):Promise<any> {
        return new Promise<boolean>((resolve, reject) => {
          this.companySettingsService
            .getCompanySystemSettings(id)
            .subscribe((data: any | undefined) => {
              this.companySettings = data;
              console.log("MEauring unit", this.companySettings?.measuringUnit)
              resolve(true);
            });
          });
          }

      async getImagePhotos(data: any, id: any):Promise<any> {
        return new Promise<boolean>((resolve, reject) => {
        this.displayFilesPhotos = [];
        this.photosdisplay = [];
        this.listingSevice
          .GetAllImagesPath(data, id)
          .subscribe((data: any | undefined) => {
            this.displayFilesPhotos = data.result == null ? []:data.result;
            if(this.displayFilesPhotos.length >= this.maxImageCount) {
              for(i=0; i<this.displayFilesPhotos.length;i++) {
                const album = {
                  src: this.baseUrl + this.displayFilesPhotos[i].imagePath,
                  caption: '',
                  thumb: ''
               };
                this.slides.push(album);
              }
              for(var i=0; i<this.maxImageCount; i++) {
                  this.photosdisplay.push(this.baseUrl + this.displayFilesPhotos[i].imagePath);
              }
            }
            else if(this.displayFilesPhotos.length == 0) {
              for(var i=0; i<this.maxImageCount; i++) {
                if(this.listingDeafaultImage != null) {
                this.photosdisplay.push(this.listingDeafaultImage);
                const album = {
                  src: this.listingDeafaultImage,
                  caption: '',
                  thumb: ''
               };
                this.slides.push(album);
                }
            }
            }
            else if(this.displayFilesPhotos.length < this.maxImageCount) {
              for(var i=0; i<this.displayFilesPhotos.length; i++) {
                this.photosdisplay.push(this.baseUrl + this.displayFilesPhotos[i].imagePath);
                const album = {
                  src: this.baseUrl + this.displayFilesPhotos[i].imagePath,
                  caption: '',
                  thumb: ''
               };
                this.slides.push(album);
            }
            if(this.maxImageCount - this.displayFilesPhotos.length > 0) {
              for(var i=0; i<this.maxImageCount - this.displayFilesPhotos.length; i++) {
                if(this.listingDeafaultImage != undefined && this.listingDeafaultImage != null) {
                this.photosdisplay.push(this.listingDeafaultImage);
                const album = {
                  src: this.listingDeafaultImage,
                  caption: '',
                  thumb: ''
               };
                this.slides.push(album);
                }
              }
            }
            }
           
            // this.slides = this.photosdisplay;
            this.cdr.detectChanges();
            if (this.displayFilesPhotos.length > 4) {
              this.display1stImage = true;
              this.display2ndImage = true;
              this.display3rdImage = true;
              this.display4thImage = true;
            } else if (this.displayFilesPhotos.length > 3) {
              this.display1stImage = true;
              this.display2ndImage = true;
              this.display3rdImage = true;
              this.display4thImage = false;
            } else if (this.displayFilesPhotos.length > 2) {
              this.display1stImage = true;
              this.display2ndImage = true;
              this.display3rdImage = false;
              this.display4thImage = false;
            } else if (this.displayFilesPhotos.length > 1) {
              this.display1stImage = true;
              this.display2ndImage = false;
              this.display3rdImage = false;
              this.display4thImage = false;
            } else {
              this.display1stImage = false;
              this.display2ndImage = false;
              this.display3rdImage = false;
              this.display4thImage = false;
            }
            resolve(true);
          });
          
        });
      }

      async getListingDetail(id:any):Promise<any> {
        return new Promise<boolean>((resolve, reject) => {
          this.listingSevice
          .GetPreviewListingDetailsById(id)
          .subscribe((data: any | undefined) => {
            this.IsLoading = false;
            this.companyId = data.companyId;
            this.previewData = data;
            if (this.previewData.subLocationName != null) {
              this.mapLocation =
                'https://www.google.com/maps?q=' +
                this.previewData.subLocationName +
                ',' +
                this.previewData.locationName +
                ',' +
                this.previewData.emiratesName +
                '&output=embed';
              this.mapDisplay = true;
              this.cdr.detectChanges();
            } else if (this.previewData.locationName != null) {
              this.mapLocation =
                'https://www.google.com/maps?q=' +
                this.previewData.locationName +
                ',' +
                this.previewData.emiratesName +
                '&output=embed';
              this.mapDisplay = true;
              this.cdr.detectChanges();
            } else {
              this.mapLocation =
                'https://www.google.com/maps?q=' +
                this.previewData.emiratesName +
                '&output=embed';
              this.mapDisplay = true;
  
              this.cdr.detectChanges();
             
            }
              this.displayView = true;
              this.cdr.detectChanges();
              resolve(true);
              const agentSpeaksIds =
                this.previewData?.agentSpeaks
                  ?.split(',')
                  .map((id: any) => +id) || [];

              this.selectedLanguages = this.LanguageList.filter((lang:any) =>
                agentSpeaksIds.includes(lang.id)
              ).map((lang:any) => lang.text);
             if (this.previewData?.agentImage) {
               // Normalize the slashes and remove any leading directories
               const imagePath = this.previewData.agentImage.replace(/\\/g, '/');

               this.agentPhoto = `${this.baseUrlImage}${this.companyId}/${imagePath}`;
               console.log('agentimage---->>>>',this.agentPhoto)
               debugger
             } 
          });
          });
      }


      closePhotos() {
        this.modalRef.close(this.modalConfig);
      }

      openPhotosslider(i:any) {
        try {
        this._lightbox.open(this.slides, i,{ wrapAround: true, showImageNumberLabel: true, centerVertically: true });
        }
        catch(error) {
        }
        // this.IsLoading = true;
        // this.cdr.detectChanges();
        // // this.reOrderslides = [
        // //   ...this.slides.slice(i),
        // //   ...this.slides.slice(0, i)
        // // ];

        // this.reOrderslides = this.slides;

        // // return new Promise<boolean>((resolve) => {
        //   // this.modalRef = this.modalService.open(this.modalContent, { size: 'xl', windowClass: 'lightbox-images' });
        //   this.modalRef = this.modalService.open(this.modalContent, { size: 'xl' });
        //   this.IsLoading = false;
        //   // this.modalRef.result.then(resolve, resolve);
        //   this.modalRef.shown.subscribe((data:any) => {
        //     this.IsLoading = false;
        //     this.cdr.detectChanges();
        //   })
        // // });
      }

      // slides = [
      //   {img: "http://placehold.it/350x150/000000"},
      //   {img: "http://placehold.it/350x150/111111"},
      //   {img: "http://placehold.it/350x150/333333"},
      //   {img: "http://placehold.it/350x150/666666"}
      // ];
      slides:any = [];
      reOrderslides:any = [];
      slideConfig = {"slidesToShow": 1, "slidesToScroll": 1};

      
      slickInit(e:any) {
        console.log('slick initialized');
      }

      
      breakpoint(e:any) {
        console.log('breakpoint');
      }
      
      afterChange(e:any) {
        console.log('afterChange');
      }
      
      beforeChange(e:any) {
        console.log('beforeChange');
      }
      trackBy(index:any,item:any) {
        return item;
      }

      close(): void {
        // close lightbox programmatically
        this._lightbox.close();
      }
      LanguageList: any = [
  { id: 1, checked: false, text: 'Arabic' },
  { id: 2, checked: false, text: 'English' },
  { id: 3, checked: false, text: 'Urdu' },
  { id: 4, checked: false, text: 'Hindi' },
  { id: 5, checked: false, text: 'Farsi (Persian)' },
  { id: 6, checked: false, text: 'Punjabi' },
  { id: 7, checked: false, text: 'Tagalog' },
  { id: 8, checked: false, text: 'Malayalam' },
  { id: 9, checked: false, text: 'Tamil' },
  { id: 10, checked: false, text: 'Telugu' },
  { id: 11, checked: false, text: 'Bengali' },
  { id: 12, checked: false, text: 'Pashto' },
  { id: 13, checked: false, text: 'Nepali' },
  { id: 14, checked: false, text: 'Sinhalese' },
  { id: 15, checked: false, text: 'French' },
  { id: 16, checked: false, text: 'Russian' },
  { id: 17, checked: false, text: 'Turkish' },
  { id: 18, checked: false, text: 'Somali' },
  { id: 19, checked: false, text: 'Amharic' },
  { id: 20, checked: false, text: 'Tigrinya' },
  { id: 21, checked: false, text: 'Azerbaijani' },
  { id: 22, checked: false, text: 'Kurdish' },
  { id: 23, checked: false, text: 'Dari' },
  { id: 24, checked: false, text: 'Chittagonian' },
  { id: 25, checked: false, text: 'Gujarati' },
  { id: 26, checked: false, text: 'Kannada' },
  { id: 27, checked: false, text: 'Marathi' },
  { id: 28, checked: false, text: 'Saraiki' },
  { id: 29, checked: false, text: 'Hebrew' },
  { id: 30, checked: false, text: 'Chinese (Mandarin)' },
  { id: 31, checked: false, text: 'Indonesian' },
  { id: 32, checked: false, text: 'Romanian' },
  { id: 33, checked: false, text: 'Ukrainian' },
  { id: 34, checked: false, text: 'Italian' },
  { id: 35, checked: false, text: 'Spanish' },
  { id: 36, checked: false, text: 'German' },
  { id: 37, checked: false, text: 'Bosnian' },
  { id: 38, checked: false, text: 'Serbian' },
  { id: 39, checked: false, text: 'Greek' },
  { id: 40, checked: false, text: 'Thai' },
  { id: 41, checked: false, text: 'Vietnamese' },
  { id: 42, checked: false, text: 'Malay' },
  { id: 43, checked: false, text: 'Balochi' },
  { id: 44, checked: false, text: 'Chechen' },
  { id: 45, checked: false, text: 'Kazakh' },
  { id: 46, checked: false, text: 'Uzbek' },
  { id: 47, checked: false, text: 'Swahili' },
  { id: 48, checked: false, text: 'Igbo' },
  { id: 49, checked: false, text: 'Yoruba' },
  { id: 50, checked: false, text: 'Filipino' }
];
getAgentInitials(name: string): string {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  const initials = parts.map(part => part[0]).slice(0, 2).join('');
  return initials.toUpperCase();
}
      
}
